import React from 'react';
import { SelectValueViewer } from 'components';
import { SecurityValueViewerProps } from './SecurityValueViewer.props';
import { useCashFlowContext } from '../context/CashFlowContext';

const SecurityValueViewer = (props: SecurityValueViewerProps) => {
  const { securityOptionsByEntity } = useCashFlowContext();

  // Get all securities across all entities (flatten the dictionary)
  const allSecurityOptions = Object.values(securityOptionsByEntity).flat();

  return <SelectValueViewer {...props} options={allSecurityOptions} />;
};

export default SecurityValueViewer;
